<div class="notification" *ngIf="isAdmission">
  {{ message }}
  <a [href]="messageLink" target="_blank" class="contact-link">{{
    linkText
  }}</a>
</div>
